export default "__VITE_ASSET__CAhHm_iD__"